/* RESPONSIBLE TEAM: team-inbox */

/**
 * Parses a newline-separated list of "monitorId:value" pairs and returns the value
 * matching the given monitorId. Handles colons in values (e.g. UUIDs).
 */
export function getValueFromMonitorPairs(pairsValue: string, monitorId: string): string | null {
  let pairs = pairsValue.split('\n').filter(Boolean);
  for (let pair of pairs) {
    let [key, ...rest] = pair.split(':');
    if (key === monitorId) {
      return rest.join(':');
    }
  }
  return null;
}
